function normalizeStopIdValue(value) {
  return String(value || "");
}

export function getPublicStopId(stopOrId) {
  if (stopOrId && typeof stopOrId === "object") {
    return normalizeStopIdValue(
      stopOrId.public_stop_id ??
        stopOrId.stop_public_id ??
        stopOrId.parent_station ??
        stopOrId.stop_id,
    );
  }

  return normalizeStopIdValue(stopOrId);
}

// Temporary fallback for legacy localStorage records that still use `sms`.
// Remove after the stop storage migration has baked for a few months.
export function stopIdMatches(stopOrId, publicStopId) {
  const stopIdText = getPublicStopId(stopOrId);
  const publicStopIdText = normalizeStopIdValue(publicStopId);

  if (!stopIdText || !publicStopIdText) {
    return false;
  }

  if (stopIdText === publicStopIdText) {
    return true;
  }

  // Wellington can have child/platform stop ids keyed by a short public SMS.
  // Do not apply prefix matching to longer ids because Otago stop codes collide.
  return (
    publicStopIdText.length <= 4 && stopIdText.startsWith(publicStopIdText)
  );
}

export function getStoredStopId(record) {
  if (!record || typeof record !== "object") {
    return null;
  }

  return record.stop_id ?? record.sms ?? null;
}

// Temporary compatibility write shape while legacy localStorage readers
// still expect `sms`. Remove once the sms deprecation window ends.
export function withStoredStopId(record, stopId) {
  if (!record || typeof record !== "object") {
    return {
      stop_id: stopId,
      sms: stopId,
    };
  }

  return {
    ...record,
    stop_id: stopId,
    sms: stopId,
  };
}

export function hasStoredStopId(record, stopId) {
  return getStoredStopId(record) === stopId;
}

export function hasFavouriteStopId(favourites, stopId) {
  if (!Array.isArray(favourites) || stopId == null) {
    return false;
  }

  const normalizedStopId = String(stopId);

  return favourites.some((favourite) => {
    const favouriteStopId =
      favourite && typeof favourite === "object"
        ? getStoredStopId(favourite)
        : favourite;

    return (
      favouriteStopId != null && String(favouriteStopId) === normalizedStopId
    );
  });
}

export function getTripStopRowId(stopId, publicStopId) {
  return stopIdMatches(stopId, publicStopId)
    ? String(publicStopId)
    : String(stopId);
}

export function getPreferredStopName(preferredStopNames, stopId, publicStopId) {
  if (!Array.isArray(preferredStopNames)) {
    return null;
  }

  const exactMatch = preferredStopNames.find(
    (preferredStop) => getStoredStopId(preferredStop) === stopId,
  );

  if (exactMatch?.name) {
    return exactMatch.name;
  }

  const publicMatch = preferredStopNames.find(
    (preferredStop) =>
      publicStopId &&
      getStoredStopId(preferredStop) === publicStopId &&
      stopIdMatches(stopId, publicStopId),
  );

  return publicMatch?.name || null;
}
